const moduleCache = {};

export const getCachedValue = (key) => {
    let item;

    if (typeof localStorage !== "undefined") {
        item = JSON.parse(localStorage.getItem(key) || "{}");
    } else {
        item = moduleCache[key] || {};
    }

    return item && (item.ttl === null || item.ttl > Date.now()) ? item.value : null;
};

export const setCachedValue = (key, value, ttl = null) => {
    const item = {
        value,
        ttl: ttl === null ? null : Date.now() + (ttl * 1000),
    };

    if (typeof localStorage !== "undefined") {
        localStorage.setItem(key, JSON.stringify(item));
    } else {
        moduleCache[key] = item;
    }
};
